import React, { useState } from 'react';
import { Modal, Form, Input, Space, Spin, notification } from 'antd';
import PropTypes from 'prop-types';
import { Button as CrcButton } from '@crc-evans/ui-components';

const EmailModal = (props) => {
  const [form] = Form.useForm();
  const { visible, onCancel, onSubmit } = props;
  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState('');
  const onFinish = async (values) => {
    if (!values || !values.emails) {
      notification.warning({
        message: 'Please enter email addresses to proceed!',
      });
      return;
    }

    const emailsString = values.emails;

    // Ensure emailsString is a string
    if (typeof emailsString !== 'string') {
      notification.warning({
        message: 'Please enter valid email addresses to proceed!',
      });
      return;
    }
    console.log(values);
    const emails = values.emails.split(',').map((email) => email.trim());
    const invalidEmails = emails.filter((email) => !validateEmail(email));

    if (invalidEmails.length > 0) {
      notification.warning({
        message: 'Please enter valid email addresses to proceed!',
        description: `Invalid emails: ${invalidEmails.join(', ')}`,
      });
    } else {
      setLoading(true);
      await onSubmit(emails);
      form.resetFields();
      setLoading(false);
    }
  };
  const validateEmail = (email) => {
    const regexp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return regexp.test(email);
  };

  return (
    <Modal
      title={
        <span style={{ fontSize: '18px', fontWeight: 600, color: '#111827' }}>
          Share Heat Profile Report
        </span>
      }
      className="pipeline-modal heatprofile-modal"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <CrcButton
          key="cancel"
          label="Cancel"
          variant="secondary"
          onClick={onCancel}
        />,
        <CrcButton
          key="submit"
          label="Submit"
          variant="primary"
          onClick={() => form.submit()}
          disabled={email.length === 0}
          style={email.length === 0 ? { opacity: 0.5, marginLeft: '8px' } : { marginLeft: '8px' }}
        />,
      ]}
      style={{ zIndex: 1002 }}
      width={480}
      centered
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          style={{ marginTop: '20px' }}
        >
          <Form.Item
            label={<span style={{ fontWeight: 500, color: '#374151' }}>Email IDs</span>}
            name="emails"
            required
            extra={<span style={{ fontSize: '12px', color: '#6b7280' }}>eg: 1234@mail.com, 234@email.com</span>}
          >
            <Input
              placeholder="Enter emails followed by comma (,)"
              size="large"
              style={{ borderRadius: '6px' }}
              onChange={(e) => setEmail(e.target.value.toLowerCase())}
            />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

EmailModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default EmailModal;
